import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnInit,
    inject
} from "@angular/core";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { TranslatePipe } from "@ngx-translate/core";
import { KontaktDTO } from "~app/common/models/kontakter/KontaktDTO";
import { EmailUtils } from "~app/common/utils/email-utils";
import { SafePipe } from "../../../../../common/pipes/safe.pipe";
import { LeverantorDialogService } from "../../dialog/leverantor-dialog.service";
import { ISearchVirkesleverantor } from "../../models/virkesleverantorModel";
import { VirkesleverantorListViewModel } from "../models/virkesleverantorViewModels";

@Component({
    selector: "rask-virkesleverantor-list",
    templateUrl: "./virkesleverantor-list.component.html",
    styleUrls: ["./virkesleverantor-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ListComponent,
        ListColumnDirective,
        TranslatePipe,
        SafePipe
    ]
})
export class VirkesleverantorListComponent implements OnInit {
    @Input() autoOpenLeverantor?: number;

    protected leverantorer: VirkesleverantorListViewModel[];

    private readonly changeDetector = inject(ChangeDetectorRef);
    private readonly leverantorDialogService = inject(LeverantorDialogService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("leverantorer") set list(val: ISearchVirkesleverantor[]) {
        if (!val) {
            return;
        }
        this.leverantorer = val.map((x: ISearchVirkesleverantor) => new VirkesleverantorListViewModel(x));
    }

    ngOnInit(): void {
        if(this.autoOpenLeverantor) {
            this.openRedigeraLeverantorDialog(null, this.autoOpenLeverantor);
        }
    }

    protected isEmailValid = (email: string): boolean => EmailUtils.isValid(email);

    protected openRedigeraLeverantorDialog(event: Event, id?: number) {
        event?.preventDefault();
        this.leverantorDialogService.open(id, undefined, lev => {
            const currIndex = this.leverantorer.findIndex(x => x.id === lev?.id);
            if (currIndex < 0) {
                return;
            }

            const leverantorer = [...this.leverantorer];
            leverantorer[currIndex] = new VirkesleverantorListViewModel(this.mapToLev(lev));
            this.leverantorer = leverantorer;
            this.changeDetector.detectChanges();
        });
    }

    private mapToLev(lev: KontaktDTO): ISearchVirkesleverantor {
        return {
            id: lev.id,
            namn: lev.kontaktNamn,
            fornamn: lev.kontaktpersonFornamn,
            efternamn: lev.kontaktpersonEfternamn,
            orgnr: lev.kontaktOrgnummer,
            limeId: lev.kontaktLimeId,
            huvudkontor: null,
            kontaktperson: "",
            adress: lev.kontaktAdress,
            adress2: lev.kontaktAdress2,
            postnummer: lev.kontaktPostnummer,
            postort: lev.kontaktPostort,
            telefon: lev.kontaktTelefon,
            mobil: lev.kontaktKontaktMobiltelefon,
            epost: lev.kontaktKontaktEpost,
            grupp: lev.gruppering,
            ansvarigVirkeskopare: lev.ansvarigVirkeskopare
                ? `${lev.ansvarigVirkeskopare.fornamn} ${lev.ansvarigVirkeskopare.efternamn}`
                : "",
            klassning: lev.klassning,
            momskod: lev.momskod,
            momsnummerEjAktuellt: lev.momsnummerEjAktuellt,
            momsnummerKontrollerat: lev.momsnummerKontrollerat,
            momsnummerValideringsstatus: lev.momsnummerValideringsstatus,
            momsnummerValideringstid: lev.momsnummerValideringstid,
            momsregistreringsnummer: lev.momsregistreringsnummer,
            anskaffningsform: lev.anskaffningsform
        };
    }
}
